import { useMemo } from 'react';

import LinkBankAccount from './LinkOpenBankingRevamp/LinkBankAccount';
import { useGetContext } from '../../../../api/lendingApi/lendingApiQueries';
import { getLinkedBankAccountDetails } from '../../OpenBanking/trueLayer.helpers';
import { useStep } from '../StepContext';

const BankStatements = () => {
  const { isActive, onRequestUpload, showDirectUpload, requirement } =
    useStep();
  const { context } = useGetContext();

  const resolutionMethods = requirement.resolution_methods;

  const linkedBankAccount = useMemo(() => {
    if (!resolutionMethods || !context) return undefined;
    return getLinkedBankAccountDetails(resolutionMethods, context);
  }, [resolutionMethods, context]);

  return (
    <LinkBankAccount
      linkedBankAccount={linkedBankAccount}
      isActive={isActive}
      onRequestUpload={onRequestUpload}
      showDirectUpload={showDirectUpload}
    />
  );
};

export default BankStatements;
